var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0c.986 0 1.786.8 1.786 1.786l-.001 8.928h8.93a1.786 1.786 0 110 3.572l-8.93-.001v8.93a1.786 1.786 0 11-3.57 0l-.001-8.93H1.786a1.786 1.786 0 110-3.57l8.928-.001V1.786c0-.987.8-1.786 1.786-1.786z"
  })));
}

export default SvgCommonIconPlus;